import styles from './NoAudios.module.css'

export type TNoAudiosProps = {
    title: string
    description: string
}

export const NoAudios = ({ title, description }: TNoAudiosProps) => (
    <div data-test="collection-no-audios" className={styles.empty}>
        <p className={styles.title}>{title}</p>
        <p className={styles.description}>{description}</p>
    </div>
)
